export const loadCloudComputerInlineLiveView = () =>
  import('@heidi/agents').then((mod) => ({
    default: mod.CloudComputerInlineLiveView,
  }));

export const loadDesktopControlApprovalWarning = () =>
  import('@heidi/agents').then((mod) => ({
    default: mod.DesktopControlApprovalWarning,
  }));

export const loadCloudComputerExpandButton = () =>
  import('@heidi/agents').then((mod) => ({
    default: mod.CloudComputerExpandButton,
  }));

export const loadCloudComputerLightbox = () =>
  import('@heidi/agents').then((mod) => ({
    default: mod.CloudComputerLightbox,
  }));

export const loadCloudComputerLiveView = () =>
  import('@heidi/agents').then((mod) => ({
    default: mod.CloudComputerLiveView,
  }));
